import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { initPwaInstall } from "@/utils/pwaInstall";
import { isKayiComNativeApp } from "@/utils/androidApp";
import { refreshSiteCache } from "@/utils/siteCache";

const registerServiceWorker = () => {
  try {
    const host = window.location.hostname;
    const isLocalhost = host === "localhost" || host === "127.0.0.1" || host === "[::1]";
    if (
      "serviceWorker" in navigator &&
      !isKayiComNativeApp() &&
      !isLocalhost
    ) {
      navigator.serviceWorker.register("/service-worker.js").then((reg) => {
        try { reg.update(); } catch { /* ignore */ }
        if (reg.waiting) {
          try { reg.waiting.postMessage({ type: "SKIP_WAITING" }); } catch { /* ignore */ }
        }
      }).catch(() => {
        // ignore — install prompt just won't be offered
      });
      navigator.serviceWorker.addEventListener("controllerchange", () => {
        try {
          if (sessionStorage.getItem("kayicom-sw-reload-20261010a")) return;
          sessionStorage.setItem("kayicom-sw-reload-20261010a", "1");
        } catch {
          return;
        }
        window.location.reload();
      });
    }
  } catch {
    // ignore
  }
};

const mountApp = () => {
  try {
    const seo = document.getElementById("seo-prerender");
    if (seo) seo.remove();
  } catch {
    // ignore
  }

  const root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );

  try {
    window.__kayicomAppReady = true;
    window.dispatchEvent(new Event("kayicom-app-ready"));
  } catch {
    // ignore
  }
};

(async () => {
  try {
    initPwaInstall();
  } catch {
    // ignore
  }

  let result = { reloaded: false };
  try {
    result = await refreshSiteCache();
  } catch {
    result = { reloaded: false };
  }
  if (result?.reloaded) return;

  registerServiceWorker();
  mountApp();
})();
